import React, { useMemo } from 'react';
import { Col } from 'react-styled-flexboxgrid';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bodyMRegularBrownStyles, bodySRegularBrownStyles } from '../../../styles/typography';
import { bpWidth, colors } from '../../../styles/variables';
import { renderRichTextReact } from '../../../utils/storyblokRichText';

const WrapperCol = styled(Col)`
  ${bodyMRegularBrownStyles};
  padding: 15px 0 12px 0;
  line-height: 1;

  @media (${bpWidth.desktopSm}) {
    ${bodySRegularBrownStyles};
    padding: 13px 0 10px 0;
  }

  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ isActive }) => (isActive ? colors.beige100 : colors.beige700)} !important;
  background-color: ${({ isActive }) => (isActive ? colors.beige700 : colors.beige200)};
  border-bottom: 1px solid ${colors.beige700};

  :not(:last-of-type) {
    border-right: 1px solid ${colors.beige700};
  }
`;

const MobileTitle = styled.div`
  display: none;

  @media (${bpWidth.mobile}) {
    display: block;
  }
`;

const BiggerThanMobileTitle = styled.div`
  display: block;

  @media (${bpWidth.mobile}) {
    display: none;
  }
`;

const TabHeader = ({ uid, activeTab, setActiveTab, title, mobileTitle }) => {
  const isActive = useMemo(() => activeTab === uid, [activeTab, uid]);
  const xsCol = useMemo(() => (isActive ? 5 : 3), [isActive]);
  const cssClass = useMemo(
    () => ['tabs-component--header', isActive ? 'tabs-component--header-active' : undefined].filter(Boolean).join(' '),
    [isActive],
  );
  const titleRichText = useMemo(() => renderRichTextReact(title), [title]);
  const mobileTitleRichText = useMemo(() => renderRichTextReact(mobileTitle), [mobileTitle]);

  const handleTabClick = () => {
    setActiveTab(uid);
  };

  return (
    <WrapperCol
      isActive={activeTab === uid}
      xs={xsCol}
      sm={4}
      md={5}
      lg={6}
      onClick={handleTabClick}
      className={cssClass}
    >
      <BiggerThanMobileTitle>{titleRichText}</BiggerThanMobileTitle>
      <MobileTitle>{activeTab === uid ? titleRichText : mobileTitleRichText || titleRichText}</MobileTitle>
    </WrapperCol>
  );
};

TabHeader.propTypes = {
  uid: PropTypes.string.isRequired,
  title: PropTypes.object.isRequired,
  mobileTitle: PropTypes.object,
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func.isRequired,
};

export default TabHeader;
